export default __webpack_public_path__ + "static/media/global-element-spinner.d92d1e24.svg";